<template>
  <div class="crudblock">
    <avue-crud
      :option="option"
      :data="data"
      v-model="form"
      ref="crud"
      :page.sync="page"
      :search.sync="form"
      @setCurrent="setCurrent"
      @selection-change="selectionChange"
      @select="selectone"
      @search-reset="searchReset"
      @on-load="onLoad"
      @search-change="searchChange"
      @sort-change="sortChange"
    >
      <template slot="searchMenu" slot-scope="{ row }">
        <el-button type="primary" @click="save(row)">保存</el-button>
        <el-button type="primary" @click="screen"
          ><a-icon type="filter" /> 高级筛选</el-button
        >
      </template>
      <template slot="menuRight">
        <el-tooltip class="item" effect="dark" content="显隐" placement="top">
          <el-button
            icon="el-icon-s-operation"
            circle
            @click="operation"
          ></el-button>
        </el-tooltip>
      </template>

      <template slot="menuLeft">
        <span v-if="permission.collection_add">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-plus"
            @click="handleAdd(-1)"
          >
            添加收款</el-button
          >
          <!-- <el-button type="primary"    size="small" :disabled='wfStatusall.length>0' icon="el-icon-brush" @click="batchapproval()">
            批量报审</el-button
          > -->
        </span>
        <el-button
          type="primary"
          plain
          size="small"
          icon="el-icon-edit"
          v-if="permission.collection_edit"
          @click.stop="handleEdit"
          >编辑
        </el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete-solid"
          v-if="permission.collection_delete"
          @click.stop="handleDel"
          :disabled="disabled"
          >删除
        </el-button>
        <span v-if="permission.collection_verifier">
          <span>
            <!--   v-if="
                selectionData[0].flagVerified == 1 &&
                  selectionData[0].flagBookkeeping == 1
              "  -->
            <el-button
              size="small"
              icon="el-icon-document"
              @click="verification"
              :disabled="financialdisabled && flagVerified != 1"
              >核销</el-button
            >
            <!--    v-if="
                selectionData[0].flagVerified == 2 &&
                  selectionData[0].flagBookkeeping == 1
              " -->
            <el-button
              size="small"
              icon="el-icon-d-caret"
              @click="returnback"
              :disabled="
                (financialdisabled && flagVerified != 2) || flagBookkeeping == 2
              "
              >回退</el-button
            >
            <!--    v-if="
                selectionData[0].flagVerified>= 2 &&
                  selectionData[0].flagBookkeeping == 1
              " -->
            <el-button
              size="small"
              icon="el-icon-menu"
              @click="bookkeeping"
              :disabled="
                financialdisabled &&
                !(flagVerified == 2 && flagBookkeeping == 1)
              "
              >记账
            </el-button>
            <!--    v-if="
                selectionData[0].flagVerified == 2 &&
                  selectionData[0].flagBookkeeping == 2
              " -->
            <el-button
              size="small"
              icon="el-icon-finished"
              @click="recoil"
              :disabled="financialdisabled && flagBookkeeping != 2"
              >反冲</el-button
            >
            <!--   v-if="
                selectionData[0].flagVerified == 1 &&
                  selectionData[0].flagBookkeeping ==1
              " -->
            <el-button
              size="small"
              icon="el-icon-close"
              @click="backoff"
              :disabled="
                (financialdisabled && flagVerified != 1) || flagBookkeeping != 1
              "
              >退回</el-button
            >
          </span></span
        >
        <el-button
          size="small"
          plain
          @click="exportShow"
          icon="el-icon-download"
          >导出数据</el-button
        >
      </template>
      <template slot-scope="{ row }" slot="collectTitle">
        <div class="project-name" @click="handleDetail(row)">
          {{ row.collectTitle }}
        </div>
      </template>
      <!-- <template slot-scope="scope" slot="menu">
        <div style="text-align: left">
          <el-button
            type="success"
            plain
            size="small"
            icon="el-icon-arrow-right"
            @click.stop="handleDetails(scope.row.id)"
            >详情
          </el-button>
          <span style="margin-left: 10px" v-if="scope.row.flagVerified == 0">
            <el-button
              type="primary"
              plain
              size="small"
              icon="el-icon-edit"
              v-if="permission.collection_edit"
              @click.stop="handleEdit(scope.row.id)"
              >编辑
            </el-button>
          </span>
          <el-button
            type="danger"
            plain
            size="small"
            icon="el-icon-delete-solid"
            v-if="userInfo.role_name.includes('admin')"
            @click.stop="handleDel(scope.row.id)"
            >删除
          </el-button>
        </div>
      </template> -->
    </avue-crud>
    <el-drawer
      title="高级筛选"
      :visible.sync="drawer"
      size="50%"
      custom-class="drawer_wrapper"
      :with-header="false"
    >
      <span>
        <div class="drawer_screen_wrapper">
          <div class="screen_header">
            <div class="screen_header_name">
              <a-icon type="filter" />
              高级筛选
            </div>
            <div class="screen_header_remarks" @click="drawer = false">
              <i class="el-icon-video-play"></i>
              收起
            </div>
          </div>
          <div class="screen_content">
            <avue-form
              :option="option"
              ref="form"
              v-model="form"
              @submit="handleSearch"
              @reset-change="searchResetScreen"
            >
              <template slot="collectionAmount">
                <div class="form_slot">
                  <el-input-number
                    v-model="form.collectionAmountMin"
                    :controls="false"
                    placeholder="开始数值"
                    style="width: 100%"
                  />
                  ~
                  <el-input-number
                    v-model="form.collectionAmountMax"
                    :controls="false"
                    placeholder="结束数值"
                    style="width: 100%"
                  />
                </div>
              </template>
            </avue-form>
          </div>
        </div>
      </span>
    </el-drawer>
    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="isOnly"
      :clear="false"
      @setPeople="setPeople"
    />
    <Options
      ref="Options"
      :plainOptions="showHide"
      :pageDataId="this.$route.path"
      @returnData="returnData"
    />
    <Reason ref="reasonblock" :passdata="passdata" @passcheck="passcheck" />
    <Verification ref="verif" @verificheckreturn="verificheckreturn" />
    <ExportData ref="exportData" @exportDownload="exportDownload" />
  </div>
</template>

<script>
import * as api from "@/api/zd/collection";
import { mapGetters } from "vuex";
import SelectPerson from "@/components/SelectPersonnel/person";
import { downLoadTemplate } from "@/router/downLoadTem";
import ExportData from "@/components/exportData/exportData";
import Verification from "./verificationVisible";
import Options from "@/components/ShowHidden/showhidden";
import Reason from "./reason.vue";
export default {
  data() {
    return {
      wfStatusall: [],
      passdata: {
        id: "",
        advise: "",
      },
      shlb: 0,
      form: {},
      formScreen: {},
      timepic: [],
      financialdisabled: true,
      flagVerified: 0,
      flagBookkeeping: 0,
      selectionList: [],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      data: [],
      optionchange: {},
      selectionData: [],
      selectbatchapproval: [],
      drawer: false,
      financialdata: false,
      financialform: {},
      checkUserList: [],
      isOnly: false,
      peopleName: "managerUser",
      disabled:true
    };
  },
  computed: {
    ...mapGetters(["permission", "userInfo"]),
  },
  components: {
    SelectPerson,
    Verification,
    Reason,
    Options,
    ExportData,
  },
  watch: {
    files: {
      handler(newName, oldName) {
        if (oldName != undefined) {
          this.cloudTages(newName);
        }
      },

      immediate: true,
    },
    selectionList: {
      handler(data) {
        let list = data.filter((item) => {
          return (
            item.managerUser == this.userInfo.user_id && item.auditState == 0
          );
        });

        this.disabled = data.length == 0 || list.length != data.length;
      },
      deep: true,
    },
  },
  props: ["files", "option", "conditions", "showHide"],
  mounted() {
    this.optionColumn = this.deepClone(this.option.column)
  },  
  activated() {
    this.onLoad(this.page);
  },
  methods: {
    handleDetail(data) {
      this.$router.push({
        path: `/zd/collectionmanage/collectionDetail/${data.id}`,
      });
    },
    //显隐
    operation() {
      let origencolum = this.showHide;
      this.$refs.Options.showmode();
    },
    returnData(data) {
      this.option.column = data;
    },
    setCurrent(selection) {},
    //排序
    sortChange(val) {
      this.form.orderValue =
        val.order == "descending"
          ? "desc"
          : val.order == "ascending"
          ? "asc"
          : "";
      this.form.orderName = val.prop;
      this.page.currentPage = 1;
      this.onLoad(this.page);
    },
    onLoad(page) {
      let dats = {};
      if (this.permission.collection_verifier) {
        dats.flagBookkeeping = 10;
        dats.flagVerified = 10;
      }
      dats = {
        ...dats,
        ...this.form,
        flagVerified:
          this.form.flagVerified == 0
            ? this.form.flagVerified
            : this.form.flagVerified == undefined
            ? dats.flagVerified
            : this.form.flagVerified,
        flagBookkeeping:
          this.form.flagBookkeeping == "" ||
          this.form.flagBookkeeping == undefined
            ? dats.flagBookkeeping
            : this.flagBookkeeping,
      };

      if (this.form.planDate1 != undefined) {
        dats.planDateMin = dats.planDate1[0];
        dats.planDateMax = dats.planDate1[1];
      }
      if (this.form.actualCollectDate1 != undefined) {
        dats.actualCollectDateMin = dats.actualCollectDate1[0];
        dats.actualCollectDateMax = dats.actualCollectDate1[1];
      }
      if (this.form.verificationTime1 != undefined) {
        dats.verificationTimeMin = dats.verificationTime1[0];
        dats.verificationTimeMax = dats.verificationTime1[1];
      }
      delete dats["planDate"];
      delete dats["planDate1"];
      delete dats["actualCollectDate"];
      delete dats["actualCollectDate1"];
      delete dats["verificationTime"];
      delete dats["verificationTime1"];
      // this.condition!=undefined

      dats.firstNum = (page.currentPage - 1) * page.pageSize;
      dats.num = page.pageSize;

      api
        .collectiongetgetList(dats)
        .then((res) => {
          this.auditlistNub = res.data.data.shlb;
          this.page.total = res.data.data.total;
          this.data = res.data.data.list;
          this.selectionData = [];
          this.financialdisabled == true;
          this.flagVerified = 0;
          this.flagBookkeeping = 0;
        })
        .catch((res) => {
           
        });
    },
    searchChange(params, done) {
      this.onLoad(this.page);
      done();
    },
    searchReset() {
      this.form = {};
      this.onLoad(this.page);
    },
    //高级筛选清空
    searchResetScreen() {
      this.$refs.crud.searchReset();
    },
    save(row) {
      row = { ...row };
      this.$emit("rowdata", row);
    },
    cloudTages(data) {
      this.form = data;
      this.searchChange(data);
    },

    handleAdd() {
      this.$router.push({ path: `/zd/collectionmanage/add/-1` });
    },
    handleEdit() {
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行编辑");
      } else if (this.selectionList.length == 1) {
        let data = this.selectionList[0];
        if (data.id == "-1") {
          this.$router.push({ path: `/zd/collectionmanage/add/-1` });
        } else {
          this.$router.push({ path: `/zd/collectionmanage/edit/${data.id}` });
        }
      } else {
        this.$message.error("请选择一条数据进行编辑");
      }
    },
    batchapproval() {
      let dataids = this.selectbatchapproval;
      let approvalids = dataids.map((item) => {
        return item.id;
      });

      api.submitWorkflowCheck({ ids: approvalids }).then(() => {
        this.$confirm("是否确定提交审批?", "操作确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          api
            .submitWorkflow({ ids: approvalids })
            .then((res) => {
              this.$alert(
                "数据已同步至OA系统，请您前往OA工作流中查看",
                "信息提示",
                {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    this.$message({
                      type: "info",
                      message: "请您前往OA工作流中查看",
                    });
                  },
                }
              );
              this.onLoad(this.page);
            })
            .catch((res) => {
               
            });
        });
      });
    },
    //表格选中
    selectone(selection, row) {
      this.selectionData = selection;
      if (selection.length == 0) {
        this.financialdisabled == true;
        this.flagVerified = 0;
        this.flagBookkeeping = 0;
      } else {
        this.financialdisabled == false;
        this.flagVerified = selection[0].flagVerified;
        this.flagBookkeeping = selection[0].flagBookkeeping;
      }
    },
    // 表格全选 或 全部选中
    selectionChange(list) {
      this.$emit("selectionDataItem", list);
      this.selectionList = list;
    },
    toggleSelection(val) {
      this.$refs.crud.toggleSelection(val);
    },

    exportout() {
      let data = this.form;
      data.firstNum = "";
      data.num = "";
      delete data["$auditState"];
      delete data["$bankState"];
      let exceldata = this.daochu(data);
      this.$export.excel({
        title: "银行管理",
        columns: this.option.column,
        data: exceldata,
      });
    },
    daochu(data) {
      api.bankmessagegetList(data).then((res) => {
        return res.data.data.list;
      });
    },
    verification() {
      if (this.selectionData != []) {
        this.$refs.verif.showblock(this.selectionData);
      }

      //  
    },

    //核销回传
    verificheckreturn(data) {
      api
        .changeFlagVerified({
          id: data.id,
          flagVerified: 2,
          verificationTime: data.verificationTime,
        })
        .then((res) => {
           
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.toggleSelection(this.selectionData);
          this.onLoad(this.page);
        })
        .catch((res) => {
          this.$message({
            type: "info",
            message: res.data.msg,
          });
        });
    },

    //回退
    returnback() {
      if (this.selectionData != []) {
        this.passdata.id = this.selectionData[0].id;
        this.$refs.reasonblock.showblock("huitui", this.passdata.id);
      }
    },
    //记账
    bookkeeping() {
      this.$confirm("是否确定记账此数据, 操作确认?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        api
          .changeFlagBookkeeping({
            id: this.selectionData[0].id,
            flagBookkeeping: 2,
          })
          .then((res) => {
            //  
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.toggleSelection(this.selectionData);
            this.onLoad(this.page);
          })
          .catch((res) => {
             
          });
      });
    },
    //反冲
    recoil() {
      if (this.selectionData != []) {
        this.passdata.id = this.selectionData[0].id;
        this.$refs.reasonblock.showblock("fanchong", this.passdata.id);
      }
    },
    //退回
    backoff() {
      if (this.selectionData != []) {
        this.passdata.id = this.selectionData[0].id;
        this.$refs.reasonblock.showblock("tuihui", this.passdata.id);
      }
    },

    // 原因填写返回
    passcheck(data, type) {
      if (type == "huitui") {
        api
          .changeFlagVerified({
            id: data.id,
            flagVerified: 1,
            verificationReason: data.advise,
          })
          .then((res) => {
            //  
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.toggleSelection(this.selectionData);
            this.onLoad(this.page);
          })
          .catch((res) => {
             
          });
      } else if (type == "tuihui") {
        api.changeBack({ id: data.id, backReason: data.advise }).then((res) => {
          this.onLoad(this.page);
        });
      } else {
        api
          .changeFlagBookkeeping({
            id: data.id,
            flagBookkeeping: 1,
            bookkeepingReason: data.advise,
          })
          .then((res) => {
            this.$message({
              type: "success",
              message: res.data.msg,
            });
            this.toggleSelection(this.selectionData);
            this.onLoad(this.page);
          })
          .catch((res) => {
             
          });
      }
    },

    handleDel(id) {
      let self = this;

      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api
            .collectiondelete({
              ids: self.selectionList.map((item) => {
                return item.id;
              }),
            })
            .then((res) => {
              self.$message({
                type: "success",
                message: res.data.msg,
              });
              self.$emit("selectionDataItem", []);
              self.onLoad(self.page);
            })
            .catch((res) => {
               
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //显示高级筛选抽屉
    screen() {
      this.form = { ...this.form, ...this.query };
      this.drawer = true;
    },
    //高级筛选
    handleSearch(form, done, loading) {
      this.form = { ...this.form, ...form };
      this.drawer = false;
      this.page.currentPage = 1;
      this.onLoad(this.page);
      done();
    },
    //获取 人员名称
    getVisitPeople() {
      let people = this.checkUserList.map((item) => {
        return item.realName;
      });
      let ids = this.checkUserList.map((item) => {
        return item.id;
      });
      this.$nextTick(() => {
        if (this.peopleName == "verifier") {
          this.form.verifierName = people.join(",");
          this.form.verifier = ids.join(",");
        } else {
          this.form.managerUserName = people.join(",");
          this.form.managerUserIds = ids.join(",");
        }
      });
    },
    // 人员选择插件打开
    selectPersonClick(name) {
      this.peopleName = name;
      this.isOnly = this.peopleName == "verifier" ? true : false;
      this.checkUserList = this[this.peopleName] ? this[this.peopleName] : [];

      this.$refs.selectperson.showmode();
    },

    //人员 获取
    setPeople(val) {
      this[this.peopleName] = val;
      this.checkUserList = val;
      this.getVisitPeople();
    },
    exportShow() {
      this.$refs.exportData.showModel();
    },
    exportDownload(value) {
      let page = this.page;
      let data = {
        export: value.code,
      };
      let form = this.form;
      if (value.code == 1) {
        data = {
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          ...this.query,
          ...data,
          ...form,
        };
      } else if (value.code == 2) {
        delete form["firstNum"];
        delete form["num"];
        data = {
          ...this.query,
          ...data,
          ...form,
        };
      }
      downLoadTemplate("/api/blade-/zd/collection/export", data).finally(() => {
        this.loading = false;
        this.$message({
          type: "success",
          message: "已下载",
        });
      });
    },
  },
};
</script>

<style lang="scss" scope>
.bankmanage {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .crudblock {
    background: #ffff;
    padding: 16px;
    border-radius: 4px;
    .project-name {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #409eff;
    }
    .project-name:hover {
      color: #409eff;
      cursor: pointer;
    }
  }
}
td div .bankstatediv {
  display: flex;
  flex-direction: row;
  align-items: center;

  .bankstatespan {
    display: inline-block;
    width: 8px;
    height: 8px;
    justify-content: center;
    background: red;
    margin-right: 5px;
    border-radius: 50%;
  }
  .bankstate_0 {
    background: #fec03d;
  }
  .bankstate_1 {
    background: #51d351;
  }
  .bankstate_2 {
    background: #ff7a8c;
  }
}
td div .contactName {
  display: flex;
  flex-direction: column;
}
.bankmanage .el-date-editor .el-range__icon {
  line-height: 24px;
}
.bankmanage .avue-crud .el-input__inner,
.bankmanage .avue-form .el-input__inner {
  line-height: 30px;
  height: 30px;
}
</style>
<style lang="scss" scoped>
.crudblock {
  /deep/ tr th .el-checkbox__inner {
    display: none;
  }
}
</style>
